import React, { CSSProperties, FC } from 'react';
import styles from './Card.module.scss';
import { useWindowDimensions } from '../../Helpers/Hooks/useWindowDimensions';

export interface CardProps extends React.HTMLProps<HTMLInputElement & HTMLTextAreaElement> {
	children?: any;
	withDefaultPadding?: boolean;
	withoutPadding?: boolean;
	withCentering?: boolean;
	fillVertically?: boolean;
	fillVerticallyMain?: boolean;
	fillVerticallySecond?: boolean;
	fillHalfWay?: boolean;
	noRadius?: boolean;
	mobileHeight?: string;
	style?: CSSProperties;
}

export const Card: FC<CardProps> = ({
	children,
	withDefaultPadding = false,
	withoutPadding = false,
	withCentering = false,
	fillVertically = false,
	fillVerticallyMain = false,
	fillVerticallySecond = false,
	fillHalfWay = false,
	noRadius = false,
	mobileHeight,
	style,
	...rest
}) => {
	const { isMobile } = useWindowDimensions();

	return (
		<section
			{...rest}
			className={[
				styles['card'],
				withDefaultPadding ? styles['padded'] : '',
				withoutPadding ? styles['nopadding'] : '',
				withCentering ? styles['centered'] : '',
				fillVertically ? styles['fillVertically'] : '',
				fillVerticallyMain ? styles['fillVerticallyMain'] : '',
				fillVerticallySecond ? styles['fillVerticallySecond'] : '',
				fillHalfWay ? styles['fillHalfWay'] : '',
				noRadius ? styles['noRadius'] : '',
				rest.className ? rest.className : '',
			].join(' ')}
			style={{ ...style, height: isMobile ? mobileHeight : '' }}
		>
			{children}
		</section>
	);
};
